import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";

import { useEnvironment } from "@/common/contexts/EnvironmentContext";
import api from "@/common/utils/api";
import { companyQueryKeys } from "@/company/data/companyQueryKeys";
import { ErrorResponse } from "@reflag/shared/api";
import { EntityFlagsResponse } from "@reflag/shared/flagAPI";

export function useCompanyFlagsData(companyId?: string, enabled?: boolean) {
  const { appId, envId } = useEnvironment();

  return useQuery<EntityFlagsResponse, AxiosError<ErrorResponse>>({
    queryKey: companyQueryKeys.flags(appId, envId, companyId),
    queryFn: () =>
      api
        .get<"/apps/:appId/envs/:envId/companies/:companyId/flags">(
          `/apps/${appId}/envs/${envId}/companies/${encodeURIComponent(companyId!)}/flags`,
        )
        .then((res) => res.data),
    placeholderData: keepPreviousData,
    retry: (failureCount, error) => {
      if (error.response?.status === 404) {
        return false;
      }
      return failureCount < 3;
    },
    enabled: !!appId && !!envId && !!companyId && enabled !== false,
  });
}
